import React from 'react'

const NoImg = ({ title, ...props }) => (
  <svg width="69px" height="54px" viewBox="0 0 69 54" version="1.1" {...props}>
    <title>{title}</title>
    <defs />
    <g
      id="platform-app_home_2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(-206.000000, -368.000000)"
    >
      <g id="Group-10" transform="translate(0.000000, 95.000000)">
        <g id="Group-2" transform="translate(0.000000, 200.000000)">
          <g id="Group-Copy-7" transform="translate(170.000000, 46.000000)">
            <g id="Bitmap" transform="translate(1.000000, 1.000000)">
              <g id="Group" transform="translate(34.000000, 18.000000)">
                <rect id="Rectangle" x="0" y="0" width="70" height="70" />
                <g
                  id="Group-19-Copy"
                  transform="translate(1.609195, 8.045977)"
                  fill="#EAEAEA"
                >
                  <g id="Group-18" transform="translate(0.000000, 23.333333)">
                    <path
                      d="M3.2183908,26.5517241 L39.4252874,26.5517241 L39.4252874,3.2183908 L3.2183908,3.2183908 L3.2183908,26.5517241 Z M0,0 L42.6436782,0 L42.6436782,29.7701149 L0,29.7701149 L0,0 Z"
                      id="Rectangle-13-Copy-4"
                      fillRule="nonzero"
                    />
                    <polygon
                      id="Path-18-Copy"
                      points="7.24137931 21.7241379 12.0698458 8.04597701 20.7403984 17.8422444 25.7471264 15.4344766 25.7471264 21.7241379"
                    />
                    <circle
                      id="Oval-9-Copy"
                      cx="32.9885057"
                      cy="11.2643678"
                      r="3.2183908"
                    />
                  </g>
                  <polygon
                    id="Path-18"
                    fillRule="nonzero"
                    points="27.717882 5.55903144 62.0907185 25.0188393 49.2769579 46.770556 44.5483217 44.2337349 44.8545116 48.5464014 50.9826745 51.8089932 67.6338628 23.5340694 26.2263019 0.0916287484 14.0811656 21.5364846 19.0396894 20.6115161"
                  />
                  <circle
                    id="Oval-9-Copy-4"
                    cx="49.8850575"
                    cy="29.7701149"
                    r="3.2183908"
                  />
                  <polygon
                    id="Path-20-Copy"
                    points="26.5517241 20.1149425 34.5977011 20.1149425 33.1360544 13.6781609"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default NoImg
